'use client';

import { type ReactNode, useMemo } from 'react';
import { type AbstractIntlMessages, NextIntlClientProvider, useLocale, useMessages } from 'next-intl';

export default function FeatureIntlProvider({ messages, children }: { messages: AbstractIntlMessages; children: ReactNode }) {
  const locale = useLocale();
  const shared = useMessages();
  // Feature scopes are complete top-level namespaces. Keep the shared provider
  // outside this boundary for header/settings and plain-module notifications.
  const combined = useMemo(() => ({ ...shared, ...messages }), [shared, messages]);
  return (
    <NextIntlClientProvider locale={locale} messages={combined}>
      {children}
    </NextIntlClientProvider>
  );
}
